import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeRoutes } from 'utils/navigationHelpers';
import { Routes } from 'react-router-dom';
import { AppContainer } from './styles';
import { withTheme } from 'styled-components';
import { FovMessages } from 'components';
import { removeMessage } from 'store/actions/appActions';

const App = withTheme(props => {
  const { theme } = props;
  const dispatch = useDispatch();
  const token = true;
  const appStore = useSelector(state => state.app);
  const selectedTheme = appStore.theme;

  const removeMessageById = useCallback(payload => {
    dispatch(removeMessage(payload));
  }, [ dispatch ]);

  return (
    <AppContainer theme={theme} $selectedTheme={selectedTheme}>
      <Routes>
        {makeRoutes(token)}
      </Routes>

      <FovMessages
        messages={appStore.messages}
        removeMessage={removeMessageById}
      />
    </AppContainer>
  );
});

export { App };